import connectionGuideBleAndroidDarkImage from '../assets/images/connection-guide/connection-guide-step4-ble-android-dark.webp';
import connectionGuideBleAndroidLightImage from '../assets/images/connection-guide/connection-guide-step4-ble-android-light.webp';
import installationGuideAndroidDarkVideo from '../assets/images/installation-guide/installation-guide-android-dark.mp4';
import installationGuideAndroidDarkThumbnail from '../assets/images/installation-guide/installation-guide-android-dark-thumbnail.webp';
import installationGuideAndroidLightVideo from '../assets/images/installation-guide/installation-guide-android-light.mp4';
import installationGuideAndroidLightThumbnail from '../assets/images/installation-guide/installation-guide-android-light-thumbnail.webp';
import installationGuideIosChromeDarkVideo from '../assets/images/installation-guide/installation-guide-ios-chrome-dark.mp4';
import installationGuideIosChromeLightVideo from '../assets/images/installation-guide/installation-guide-ios-chrome-light.mp4';
import installationGuideIosDarkVideo from '../assets/images/installation-guide/installation-guide-ios-dark.mp4';
import installationGuideIosDarkThumbnail from '../assets/images/installation-guide/installation-guide-ios-dark-thumbnail.webp';
import installationGuideIosLightVideo from '../assets/images/installation-guide/installation-guide-ios-light.mp4';
import installationGuideIosLightThumbnail from '../assets/images/installation-guide/installation-guide-ios-light-thumbnail.webp';
import installationGuideIos26DarkAnimation from '../assets/images/installation-guide/ios26-animations/installation-guide-ios-26-dark.webp';
import installationGuideIos26LightAnimation from '../assets/images/installation-guide/ios26-animations/installation-guide-ios-26-light.webp';
import connectionGuideAndroidDarkVideo from '../assets/videos/connection-guide/connection-guide-step4-wifi-android-dark.mp4';
import connectionGuideAndroidLightVideo from '../assets/videos/connection-guide/connection-guide-step4-wifi-android-light.mp4';
import connectionGuideAndroidThumbnail from '../assets/videos/connection-guide/connection-guide-step4-wifi-android-thumbnail.png';
import connectionGuideIosDarkVideo from '../assets/videos/connection-guide/connection-guide-step4-wifi-ios-dark.mp4';
import connectionGuideIosLightVideo from '../assets/videos/connection-guide/connection-guide-step4-wifi-ios-light.mp4';
import connectionGuideIosThumbnail from '../assets/videos/connection-guide/connection-guide-step4-wifi-ios-thumbnail.png';
import connectionGuideIos26DarkAnimation from '../assets/videos/connection-guide/ios26-animations/connection-guide-step4-wifi-ios-dark.webp';
import connectionGuideIos26LightAnimation from '../assets/videos/connection-guide/ios26-animations/connection-guide-step4-wifi-ios-light.webp';
import assetsPageNames from '../consts/config/assetsPageNames';
import themeStyle from '../consts/themeStyle';
import uaTypes from '../consts/uaTypes';

const assetsConfig = {
    [assetsPageNames.WIFI_CONNECTION_GUIDE_SLIDE_4]: {
        [themeStyle.DARK]: {
            [uaTypes.IOS]: {
                '>=26': {
                    imageSrc: connectionGuideIos26DarkAnimation,
                    thumbnailSrc: connectionGuideIosThumbnail,
                },
                default: {
                    videoSrc: connectionGuideIosDarkVideo,
                    thumbnailSrc: connectionGuideIosThumbnail,
                },
            },
            [uaTypes.ANDROID]: {
                videoSrc: connectionGuideAndroidDarkVideo,
                thumbnailSrc: connectionGuideAndroidThumbnail,
            },
            default: {
                videoSrc: connectionGuideAndroidDarkVideo,
                thumbnailSrc: connectionGuideAndroidThumbnail,
            },
        },
        [themeStyle.LIGHT]: {
            [uaTypes.IOS]: {
                '>=26': {
                    imageSrc: connectionGuideIos26LightAnimation,
                    thumbnailSrc: connectionGuideIosThumbnail,
                },
                default: {
                    videoSrc: connectionGuideIosLightVideo,
                    thumbnailSrc: connectionGuideIosThumbnail,
                },
            },
            [uaTypes.ANDROID]: {
                videoSrc: connectionGuideAndroidLightVideo,
                thumbnailSrc: connectionGuideAndroidThumbnail,
            },
            default: {
                videoSrc: connectionGuideAndroidLightVideo,
                thumbnailSrc: connectionGuideAndroidThumbnail,
            },
        },
    },
    [assetsPageNames.BLE_CONNECTION_GUIDE_SLIDE_4]: {
        [themeStyle.DARK]: {
            default: {
                imageSrc: connectionGuideBleAndroidDarkImage,
            },
        },
        [themeStyle.LIGHT]: {
            default: {
                imageSrc: connectionGuideBleAndroidLightImage,
            },
        },
    },
    [assetsPageNames.APP_INSTALLATION_GUIDE]: {
        [themeStyle.DARK]: {
            [uaTypes.IOS]: {
                [uaTypes.CHROME]: {
                    videoSrc: installationGuideIosChromeDarkVideo,
                    thumbnailSrc: installationGuideIosDarkThumbnail,
                },
                '>=26': {
                    imageSrc: installationGuideIos26DarkAnimation,
                    thumbnailSrc: installationGuideIosDarkThumbnail,
                },
                default: {
                    videoSrc: installationGuideIosDarkVideo,
                    thumbnailSrc: installationGuideIosDarkThumbnail,
                },
            },
            [uaTypes.ANDROID]: {
                videoSrc: installationGuideAndroidDarkVideo,
                thumbnailSrc: installationGuideAndroidDarkThumbnail,
            },
            default: {
                videoSrc: installationGuideAndroidDarkVideo,
                thumbnailSrc: installationGuideAndroidDarkThumbnail,
            },
        },
        [themeStyle.LIGHT]: {
            [uaTypes.IOS]: {
                [uaTypes.CHROME]: {
                    videoSrc: installationGuideIosChromeLightVideo,
                    thumbnailSrc: installationGuideIosLightThumbnail,
                },
                '>=26': {
                    imageSrc: installationGuideIos26LightAnimation,
                    thumbnailSrc: installationGuideIosLightThumbnail,
                },
                default: {
                    videoSrc: installationGuideIosLightVideo,
                    thumbnailSrc: installationGuideIosLightThumbnail,
                },
            },
            [uaTypes.ANDROID]: {
                videoSrc: installationGuideAndroidLightVideo,
                thumbnailSrc: installationGuideAndroidLightThumbnail,
            },
            default: {
                videoSrc: installationGuideAndroidLightVideo,
                thumbnailSrc: installationGuideAndroidLightThumbnail,
            },
        },
    },
};

export default assetsConfig;
